import posthog from 'posthog-js'
import Config from '../config'

let enabled = false

function hasSSOQueryParam() {
    try {
        const params = new URLSearchParams(window.location.search)
        const sso = params.get('sso')
        return sso === '1' || sso === 'true'
    } catch (e) {
        return false
    }
}

function isSSO(store) {
    try {
        if (store && store.getters && typeof store.getters.isSSO !== 'undefined') {
            if (store.getters.isSSO) return true
        }
        const persisted = localStorage.getItem('isSSO')
        if (persisted === '1') return true
    } catch (e) { /* noop */ }
    return hasSSOQueryParam()
}

export function initPosthog(store) {
    const sso = isSSO(store)
    if (sso) {
        // Assure qu'aucune collecte n'a lieu en SSO
        if (posthog && typeof posthog.opt_out_capturing === 'function') {
            posthog.opt_out_capturing()
        }
        enabled = false
        return
    }

    try {
        posthog.init(Config.posthog_key, {
            api_host: Config.posthog_host,
            capture_pageview: false,
        })
        enabled = true
    } catch (e) {
        // En cas d'échec d'init, ne pas bloquer l'app
        enabled = false
        // console.warn('PostHog init failed:', e)
    }
}

export function capture(event, properties) {
    if (!enabled) return
    try { posthog.capture(event, properties) } catch (e) { /* noop */ }
}

export function identify(distinctId, properties) {
    if (!enabled) return
    try { posthog.identify(distinctId, properties) } catch (e) { /* noop */ }
}

export function reset() {
    if (!enabled) return
    try { posthog.reset() } catch (e) { /* noop */ }
}
